query existingSubjectLeagues($scenarioId: ID!, $originId: ID!, $filter: LinkFilterInput!) {
  cube(scenarioId: $scenarioId, originId: $originId) {
    links(filter: $filter) {
      items {
        id
        code
        course {
          id
          code
          name
        }
        groups {
          id
          code
          name
        }
        bundle {
          id
          term {
            id
            code
            name
          }
        }
      }
      pageInfo {
        page
        size
        total
        hasNextPage
        hasPreviousPage
      }
    }
  }
}
